export default __webpack_public_path__ + "static/media/agenda_icon_active.f5ec6138.svg";